import React from "react";
import { useListOfTags } from "./hooks/useListOfTags";

import "./list-of-tags.css";
import Tippy from "@tippy.js/react";
import TooltipText from "../TooltipText/TooltipText";
// import Tippy from "@tippyjs/react";

// const tooltipText = (items) => {
//   return (
//     <div className="subservices-tags-container">
//       {items.map((item, index) => (
//         <span key={index} className="subservice-tag">
//           {item.label}
//         </span>
//       ))}
//     </div>
//   );
// };

const ListOfTags = ({ maxTagsToShow = 2, tags = [] }) => {
  const { numberOfExcedent } = useListOfTags(maxTagsToShow, tags);
  return (
    <ul className="list-of-tags">
      {tags.slice(0, maxTagsToShow).map((tag, index) => {
        return <li key={`${tag.id}--${index}`}>{tag.label}</li>;
      })}
      {numberOfExcedent > 0 && (
        <Tippy
          animation="scale"
          theme="light"
          content={TooltipText(tags.slice(-(tags.length - maxTagsToShow)))}
          delay={300}
          duration={[200, 100]}
          placement="top-start"
          interactive={true}
        >
          <li>{`+ ${numberOfExcedent}`}</li>
        </Tippy>
      )}
    </ul>
  );
};

export default ListOfTags;
